import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
import timing from 'common/stylesheets/mixins/timing.json';
import { TooltipEl } from 'common/components/tooltip';
import { SelectEl } from 'common/components/select';
import { UserIconEl } from 'common/widgets/user-icon';
import { IconSizeType } from 'common/constants';
import { Placement } from 'common/components/tooltip/types';
import { DropPosition } from '../constants';
export function template() {
  const dragHandlers = this.attr("is-disabled") ? {} : {
    dragover: this.helpers.onDragOver,
    dragleave: this.helpers.onDragLeave,
    drop: this.helpers.onDrop,
    dragstart: this.helpers.onDragStart,
    dragend: this.helpers.onDragEnd
  };
  const item = this.attr("item");
  return jsx("div", {
    sel: '.draggable-wrapper',
    class: {
      'is-draggable': this.attr("is-draggable"),
      'is-disabled': this.attr("is-disabled"),
      'is-dragging': this.state.isDragging,
      'drop-indicator-above': this.state.dropPosition === DropPosition.Above,
      'drop-indicator-below': this.state.dropPosition === DropPosition.Below
    },
    attrs: {
      draggable: String(!this.attr("is-disabled") && this.attr("is-draggable") && !this.state.isOverflowMenuOpen)
    },
    on: dragHandlers
  }, jsx("div", {
    sel: '.item-wrapper',
    class: {
      'is-selected': this.attr("is-selected")
    }
  }, jsx("div", {
    sel: '.gripper'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "gripper",
      empty: !this.attr("is-draggable")
    }
  })), jsx("a", {
    sel: '.item',
    attrs: {
      href: item.href,
      target: item.target,
      draggable: "false"
    },
    on: {
      click: this.helpers.onClick
    },
    class: {
      'has-overflow-menu': this.helpers.hasOverflowMenu(),
      'is-overflow-menu-open': this.state.isOverflowMenuOpen
    }
  }, jsx("div", {
    sel: '.item-label'
  }, item.label), !this.state.isOverflowMenuOpen && jsx(TooltipEl, {
    attrs: {
      placement: Placement.Right,
      delay: timing["$mp-slow-tooltip"]
    }
  }, jsx("div", {
    sel: '.tooltip'
  }, jsx("div", {
    sel: '.tooltip-label'
  }, item.label), item.userName && jsx("div", {
    sel: '.user-metadata'
  }, jsx(UserIconEl, {
    attrs: {
      name: item.userName,
      'disable-tooltip': true,
      id: item.userId,
      size: IconSizeType.Small,
      email: item.userEmail,
      'include-label': true
    }
  })))), this.helpers.hasOverflowMenu() && jsx("div", {
    sel: '.overflow-menu-wrapper',
    on: {
      click: ev => {
        // prevent item click handler from invoking
        ev.stopPropagation();
        ev.preventDefault();
      }
    },
    style: this.helpers.getOverflowMenuPosition()
  }, jsx(SelectEl, {
    sel: '.overflow-menu',
    attrs: {
      theme: "builder",
      icon: {
        leftIcon: "hor-ellipsis"
      },
      sections: item.overflowMenuSections,
      'icon-only': true,
      'menu-width': 200
    },
    on: {
      change: this.helpers.onOverflowMenuSelect,
      menuChange: this.helpers.onOverflowMenuChange
    }
  })))));
}